@if (categoryQuestions.length) {
<div [formGroup]="form" class="form-item-card card border form-modal rounded-3">
  <div class="card-header bg-white">
    <div class="fs-6 fw-bold m-0 d-flex gap-2 align-items-center">
      <app-icon [size]="26" [strokeWidth]="2" color="#ce343c" name="clipboard-list"></app-icon>
      Cuestionario de Salud
    </div>
  </div>
  <div class="card-body pt-2 p-3">
    <p class="text-muted small mb-3">Por favor, responda las siguientes preguntas de manera honesta.</p>
    @for (q of categoryQuestions; track q.id; let i = $index) {
    <div [ngClass]="{ 'border-bottom': i < categoryQuestions.length - 1 }" class="question-item py-2">
      <div class="d-flex flex-column gap-2">
        <div class="d-flex align-items-center gap-2">
          <label class="form-label mb-0 fw-semibold">{{ q.title }}</label>
          @if (q.description) {
          <app-icon [size]="16" [strokeWidth]="2" color="#6c757d" [ngbTooltip]="q.description" name="info"></app-icon>
          }
        </div>

        @switch (q.type) {
        <!-- Bool / Conditional -->
        @case ('Bool') {
        <div class="d-flex gap-3 mt-1">
          <div class="form-check form-check-inline">
            <input [formControlName]="questionKey(q)" [id]="'q_' + q.id + '_yes'" [value]="true"
              class="form-check-input focus-ring focus-ring-success" type="radio">
            <label [for]="'q_' + q.id + '_yes'" class="form-check-label fw-semibold">Sí</label>
          </div>
          <div class="form-check form-check-inline">
            <input [formControlName]="questionKey(q)" [id]="'q_' + q.id + '_no'" [value]="false"
              class="form-check-input focus-ring focus-ring-success" type="radio">
            <label [for]="'q_' + q.id + '_no'" class="form-check-label fw-semibold">No</label>
          </div>
        </div>
        @if (form.get(questionKey(q))?.touched && form.get(questionKey(q))?.hasError('required')) {
        <div class="text-danger small mt-1">Debe seleccionar una opción</div>
        }
        }

        <!-- Text -->
        @case ('Text') {
        <div class="mt-1">
          <input [formControlName]="questionKey(q)" class="form-control" type="text">
        </div>
        }

        <!-- Default (Fallback to Bool) -->
        @default {
        <div class="d-flex gap-3 mt-1">
          <div class="form-check form-check-inline">
            <input [formControlName]="questionKey(q)" [id]="'q_' + q.id + '_yes'" [value]="true"
              class="form-check-input focus-ring focus-ring-success" type="radio">
            <label [for]="'q_' + q.id + '_yes'" class="form-check-label fw-semibold">Sí</label>
          </div>
          <div class="form-check form-check-inline">
            <input [formControlName]="questionKey(q)" [id]="'q_' + q.id + '_no'" [value]="false"
              class="form-check-input focus-ring focus-ring-success" type="radio">
            <label [for]="'q_' + q.id + '_no'" class="form-check-label fw-semibold">No</label>
          </div>
        </div>
        @if (form.get(questionKey(q))?.touched && form.get(questionKey(q))?.hasError('required')) {
        <div class="text-danger small mt-1">Debe seleccionar una opción</div>
        }
        }
        }

      </div>
    </div>
    }
  </div>
</div>
}